import styled from 'styled-components';
import {dFlex, dFlexColumn, dFlexColumnCenter, dFlexColumnAlineEnd, justifyCenter, alignEnd, alignCenter} from '../../../globalVariables/GlobalFlex';

export const content = styled.div`
    ${dFlexColumn}
    height: 100%;
`;

export const poster = styled.div`
    flex: 1;
    min-height: 0;
    width: 100%;
    overflow: clip;
    background: var(--TA-color-bg-base-alt);

    img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        display: block;
    }
`;

export const details = styled.div`
    ${dFlexColumnCenter}
    flex: none;
    min-height: 110px;
    gap: var(--space-sm);
    padding: 0 10px;
    text-align: center;
    background: var(--primitive-black-05);
`;

export const title = styled.h3`
    font-size: var(--font-size-h3);
    font-weight: var(--font-weight-bold);
    line-height: 1.2;
    word-break: break-word;
`;

export const venue = styled.p`
    font-size: var(--font-size-body);
    font-weight: var(--font-weight-regular);
    line-height: 1.2;
`;

export const dateTime = styled.div`
    ${dFlex}
    ${justifyCenter}
    ${alignEnd}
    direction: ltr;
    gap: var(--space-xl);
`;

export const col = styled.div`
    ${dFlexColumnAlineEnd}
    gap: var(--space-xs);
`;

export const label = styled.span`
    font-size: var(--font-size-caption);
    font-weight: var(--font-weight-regular);
    line-height: 1.2;
`;

export const value = styled.span`
    ${dFlex}
    ${alignCenter}
    gap: var(--space-sm);
    font-size: var(--font-size-body);
    line-height: 1.2;
`;
